export enum StyleBannerEnum {
    FULL = 'FullImage',
    TRIANGLE_NOBG = 'Image_Triangle_noBg',
    TRIANGLE_WITHBG = 'Image_Triangle_BgColor',
}
